import {Modal} from 'components/ui';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {LetrusApi} from '@letrustech/letrus-api-interfaces';
import TooltipOverlay from 'components/TooltipOverlay';
import styles from './TooltipModal.module.scss';

export interface TooltipModalProps {
  isOpen: boolean;
  anotattion: ImmutableMap<LetrusApi.ReviewAnnotation>;
  className: string;
  competenceName?: string;
  gradeMessage?: string;
  onClose(): void;
}

function TooltipModal({
  isOpen,
  anotattion,
  className,
  gradeMessage,
  competenceName,
  onClose,
}: TooltipModalProps) {
  return (
    <Modal
      buttonClose={false}
      onClose={onClose}
      isOpen={isOpen}
      clickOutsideToClose
      minHeight={304}
      maxWidth={411}
    >
      <div>
        <div className={styles.modalHeader}>
          <button type="button" data-testid="close-button" onClick={onClose}>
            <FontAwesomeIcon icon="close" size="2x" color="#E94B56" />
          </button>
        </div>
        <hr className={styles.divider} />
        <div className={styles.tooltipWrapper}>
          <TooltipOverlay
            className={`TooltipOverlay--${className}`}
            message={anotattion.get('comment')}
            competence={competenceName}
            score={gradeMessage}
            entity={anotattion.toJS()}
          />
        </div>
      </div>
    </Modal>
  );
}

export default TooltipModal;
